export default __webpack_public_path__ + "static/media/val6.5f1095af.png";